<template>
  <div>
    <b-col md="12">
      <div>
        <b-card>
          <div>
            <!-- Data Table  -->
            <div class="d-flex justify-content-between mt-4 mb-2">
              <h2>{{ $t("common.invoices") }}</h2>
            </div>

            <b-table
              :items="this.invoices.data"
              responsive
              :fields="tableColumns"
              primary-key="id"
              show-empty
              empty-text="No matching results found"
              class="position-relative"
              v-if="!loading"
            >
              <template #cell(service)="data">
                <span class="text-nowrap"> Opearation </span>
              </template>
              <template #cell(amount)="data">
                <span class="text-nowrap"> {{ data.item.amount }} IQD </span>
              </template>
              <template #cell(status)="data">
                <div>
                  <ChangeInvoiceStatusDropDown
                    name="InsuranceInvoice"
                    @onEmit="$emit('onChangeStatus')"
                    endpoint="invoices"
                    :data="data.item"
                  />
                </div>
              </template>
              <!-- Column: Actions -->
              <template #cell(actions)="data">
                <div class="text-nowrap d-flex">
                  <b-button
                    v-print="SurgeryInsuranceInvoice"
                    @click="printInvoice(data.item)"
                    variant="outline-primary"
                    size="sm"
                    class="mx-4"
                  >
                    {{ $t("reception.Print Invoice") }}
                  </b-button>
                </div>
              </template>
            </b-table>
            <template v-if="loading">
              <div>
                <div class="d-flex justify-content-center mb-1">
                  <b-spinner label="Loading..." />
                </div>
              </div>
            </template>
            <div class="mx-2 mb-2">
              <b-row>
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                  <span class="text-muted"
                    >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
                  </span>
                </b-col>
                <!-- Pagination -->
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
                  @click="getInvoices()"
                >
                  <b-pagination
                    v-model="page"
                    :total-rows="this.dataCount"
                    :per-page="take"
                    first-number
                    last-number
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-card>
      </div>
      <SurgeryInsuranceInvoice :data="invoice" />
    </b-col>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BLink,
  BDropdown,
  BSpinner,
  BDropdownItem,
  BTooltip,
  BFormGroup,
  BFormSelect,
  BModal,
  BCardText,
  BFormCheckboxGroup,
  BFormCheckbox,
  BCardBody,
  BPagination,
  BTable,
  BBadge,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
const SurgeryInsuranceInvoice = () =>
  import("@/components/printables/SurgeryInsuranceInvoice.vue");
const ChangeInvoiceStatusDropDown = () =>
  import("@/components/invoices/ChangeInvoiceStatusDropDown.vue");

import ActionsButtons from "@/components/common/ActionsButtons.vue";
import DeleteModal from "@/components/modals/DeleteModal.vue";
export default {
  components: {
    BCard,
    BRow,
    BBadge,
    BCol,
    BFormInput,
    BButton,
    BLink,
    BDropdown,
    BDropdownItem,
    BTooltip,
    vSelect,
    ToastificationContent,
    VuePhoneNumberInput,
    DeleteModal,
    ActionsButtons,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BModal,
    BCardText,
    BFormCheckbox,
    BFormCheckboxGroup,
    BCardBody,
    BPagination,
    BTable,
    ChangeInvoiceStatusDropDown,
    SurgeryInsuranceInvoice,
  },
  data() {
    return {
      tableColumns: [
        {
          key: "service",
          label: this.$t("reception.service"),
          sortable: true,
        },
        {
          key: "amount",
          label: this.$t("employee.amount"),
          sortable: true,
        },
        {
          key: "amount",
          label: this.$t("employee.amount"),
          sortable: true,
        },
        {
          key: "patient_card.card_no",
          label: this.$t("emergency.Card number"),
          sortable: true,
        },
        {
          key: "surgery.title",
          sortable: true,
          label: this.$t("surgery.surgery"),
        },
        {
          key: "doctor.name",
          sortable: true,
          label: this.$t("surgery.Doctor"),
        },
        {
          key: "invoice_no",
          sortable: true,
          label: this.$t("hospital.invoice-no"),
        },
        {
          key: "status",
          sortable: true,
          label: "Status",
        },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      invoiceLatestStatus: "",
      InvoiceId: "",
      invoice: {},
      SurgeryInsuranceInvoice: {
        id: "InsuranceInvoiceId",
      },
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
      dataCount: 0,
    };
  },
  props: ["invoices"],

  mounted() {},
  methods: {
    printInvoice(item) {
      console.log("dsdsds");
      this.invoice = item;
    },
  },
};
</script>
